module.exports = "../../static/fonts/Lato-Hairline.db15ac7.ttf";


//////////////////
// WEBPACK FOOTER
// ./static/fonts/Lato-Hairline.ttf
// module id = 916
// module chunks = 2